/**
 * Reimbursement module routes
 */

import { Routes, Route } from 'react-router-dom'
import ClaimsListPage from './pages/ClaimsListPage'
import NewClaimPage from './pages/NewClaimPage'
import ClaimDetailPage from './pages/ClaimDetailPage'
import PendingApprovalsPage from './pages/PendingApprovalsPage'
import PolicyManagementPage from './pages/PolicyManagementPage'
import PaymentsPage from './pages/PaymentsPage'
import PaymentHistoryPage from './pages/PaymentHistoryPage'
import ApprovalThresholdsPage from './pages/ApprovalThresholdsPage'
import ReimbursementReportPage from './pages/ReimbursementReportPage'

const ReimbursementRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ClaimsListPage />} />
      <Route path="/claims" element={<ClaimsListPage />} />
      <Route path="/new" element={<NewClaimPage />} />
      <Route path="/claims/:id" element={<ClaimDetailPage />} />
      <Route path="/approve" element={<PendingApprovalsPage />} />
      <Route path="/payments" element={<PaymentsPage />} />
      <Route path="/payments/history" element={<PaymentHistoryPage />} />
      <Route path="/policies" element={<PolicyManagementPage />} />
      <Route path="/approval-thresholds" element={<ApprovalThresholdsPage />} />
      <Route path="/reports" element={<ReimbursementReportPage />} />
    </Routes>
  )
}

export default ReimbursementRoutes
